var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-col p-4 applicationCard bg-white transition delay-75 duration-200 ease-in-out",
    },
    [
      _c(
        "div",
        { staticClass: "flex justify-between items-center mb-6" },
        [
          _c("Badge", {
            class: _vm.badgeData.class,
            attrs: { color: _vm.badgeData.color, value: _vm.badgeData.value },
          }),
          _c(
            "GoToInbox",
            {
              attrs: { recipientUserId: _vm.user.id },
              on: { "link-click": _vm.onMessageLinkedClicked },
            },
            [_c("ChatIconNew", { attrs: { fill: "#717986" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mb-1.5" },
        [
          _c(
            "RouterLink",
            { attrs: { to: _vm.applicantProfileRoute } },
            [
              _c("CardAvatar", {
                staticClass: "cursor-pointer text-primary-600",
                attrs: {
                  image: _vm.userAvatar,
                  initial: _vm.userInitials,
                  parentStyle: true,
                  available: _vm.user.available,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex gap-2 items-center" },
        [
          _c("RouterLink", { attrs: { to: _vm.applicantProfileRoute } }, [
            _c(
              "p",
              {
                staticClass:
                  "leading-5 text-lg font-medium mb-2 inline text-badgeBlue",
              },
              [_vm._v(" " + _vm._s(_vm.userFullName) + " ")]
            ),
          ]),
          _vm.getContractorIfInSameComapny
            ? _c("CardInfoChip", [
                _c("span", { staticClass: "text-sm text-gray-700 ml-1" }, [
                  _vm._v(" New Applicant "),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "overflow-ellipsis flex mt-1 text-storm-gray items-flex-start",
        },
        [
          _c(
            "svg",
            {
              staticClass: "mr-2",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "17",
                height: "16",
                viewBox: "0 0 17 16",
                fill: "none",
              },
            },
            [
              _c("g", { attrs: { "clip-path": "url(#clip0_586_4025)" } }, [
                _c("path", {
                  attrs: {
                    d: "M14.5 6.6665C14.5 11.3332 8.5 15.3332 8.5 15.3332C8.5 15.3332 2.5 11.3332 2.5 6.6665C2.5 5.0752 3.13214 3.54908 4.25736 2.42386C5.38258 1.29864 6.9087 0.666504 8.5 0.666504C10.0913 0.666504 11.6174 1.29864 12.7426 2.42386C13.8679 3.54908 14.5 5.0752 14.5 6.6665Z",
                    stroke: "black",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M8.5 8.6665C9.60457 8.6665 10.5 7.77107 10.5 6.6665C10.5 5.56193 9.60457 4.6665 8.5 4.6665C7.39543 4.6665 6.5 5.56193 6.5 6.6665C6.5 7.77107 7.39543 8.6665 8.5 8.6665Z",
                    stroke: "black",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]),
              _c("defs", [
                _c("clipPath", { attrs: { id: "clip0_586_4025" } }, [
                  _c("rect", {
                    attrs: {
                      width: "16",
                      height: "16",
                      fill: "white",
                      transform: "translate(0.5)",
                    },
                  }),
                ]),
              ]),
            ]
          ),
          _c("p", { staticClass: "text-sm" }, [
            _vm._v(_vm._s(_vm.userLocation)),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "overflow-ellipsi adjustCard" },
        [
          _vm.getContractorIfInSameComapny
            ? _c("RatingStars", {
                staticClass: "-ml-0.5 mb-1",
                attrs: {
                  value: _vm.getContractorIfInSameComapny.rating,
                  starSize: 15,
                  readOnly: "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.showInterviewerInfo
        ? _c(
            "div",
            [
              _vm.showInterviewerText
                ? _c("CardInfoChip", {
                    attrs: {
                      message: _vm.invitedToInterviewBadgeText,
                      green: "",
                      textclass: "text-base",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "flex flex-wrap justify-between" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", [
            _c("div", { staticClass: "space-y-1" }, [
              _c("div", { staticClass: "flex items-center" }, [
                _c(
                  "p",
                  { staticClass: "w-28 flex items-center gap-2 text-sm" },
                  [
                    _c("UserIcon", { staticClass: "h-4 w-4" }),
                    _vm._v(" Title "),
                  ],
                  1
                ),
                _c("span", { staticClass: "text-storm-gray text-sm" }, [
                  _vm._v(_vm._s(_vm.userOccupation)),
                ]),
              ]),
              _c("div", { staticClass: "flex items-center" }, [
                _c(
                  "p",
                  { staticClass: "w-28 flex items-center gap-2 text-sm" },
                  [
                    _c("DollarIcon", { staticClass: "h-4 w-4" }),
                    _vm._v(" Rate "),
                  ],
                  1
                ),
                _c("span", { staticClass: "text-storm-gray text-sm" }, [
                  _vm._v(_vm._s(_vm.userRates)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c(
                    "p",
                    { staticClass: "w-28 flex items-center gap-2 text-sm" },
                    [
                      _c("FileAttachmentIcon", {
                        staticClass: "h-4 w-4",
                        attrs: { fill: "black", stroke: "white" },
                      }),
                      _vm._v(" Attachment "),
                    ],
                    1
                  ),
                  _vm.attachedDocumentName
                    ? _c("DocumentProvider", {
                        attrs: {
                          document: _vm.attachedDocument,
                          currentUserRole: _vm.currentUser.role,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ download }) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center" },
                                    [
                                      _c(
                                        "ColorIconContainer",
                                        {
                                          staticClass:
                                            "h-6 w-full flex items-center",
                                          on: { click: download },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-blue sm:truncate resumeWidth mr-1 text-sm",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.attachedDocumentName
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("DownloadIcon", {
                                            staticClass: "w-4 h-4",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          314430458
                        ),
                      })
                    : _c(
                        "p",
                        { staticClass: "text-storm-gray font-normal text-sm" },
                        [_vm._v("n/a")]
                      ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex items-center" },
                [
                  _c(
                    "p",
                    { staticClass: "w-28 flex items-center gap-2 text-sm" },
                    [
                      _c("MessageIcon", { staticClass: "h-4 w-4" }),
                      _vm._v(" Comment "),
                    ],
                    1
                  ),
                  _vm.note
                    ? _c("UiButton", {
                        staticClass: "text-sm",
                        attrs: {
                          variant: "linkButton",
                          buttonText: "View",
                          fullWidth: "",
                          buttonClasses: "b-view_link_btn",
                          size: "sm",
                        },
                        on: {
                          click: function ($event) {
                            _vm.notedialogOpen = true
                          },
                        },
                      })
                    : _c(
                        "p",
                        { staticClass: "text-storm-gray font-normal text-sm" },
                        [_vm._v("n/a")]
                      ),
                ],
                1
              ),
              _c("div", { staticClass: "flex items-center" }, [
                _c(
                  "p",
                  { staticClass: "w-28 flex items-center gap-2 text-sm" },
                  [
                    _c("AppliedIcon", { staticClass: "h-4 w-4" }),
                    _vm._v(" Applied "),
                  ],
                  1
                ),
                _c("span", { staticClass: "text-storm-gray text-sm" }, [
                  _vm._v(
                    _vm._s(
                      _vm._f("moment")(
                        _vm.application.created_at,
                        "D MMM, YYYY"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        !_vm.isApplicationWithdrawn
          ? _c(
              "div",
              { staticClass: "flex flex-col w-full mt-4" },
              [
                _c("ApplicantStatusSelect", {
                  staticClass: "mb-4",
                  attrs: { getcontainerStyle: "customWidthInput smallHeight" },
                  on: { statusChosen: _vm.statusChosen },
                  model: {
                    value: _vm.statusDropdownValue,
                    callback: function ($$v) {
                      _vm.statusDropdownValue = $$v
                    },
                    expression: "statusDropdownValue",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "flex flex-col gap-3" },
                  [
                    _c("UiButton", {
                      attrs: {
                        variant: "default",
                        buttonText: "Update Status",
                        processing: _vm.processing,
                        fullWidth: "",
                        disabled: _vm.disableButton,
                        size: "sm",
                      },
                      on: { click: _vm.updateApplicantStatus },
                    }),
                    _c("InterviewButton", {
                      attrs: {
                        currentUserId: _vm.currentUser.id,
                        applicantUserId: _vm.user.id,
                        applicantName: _vm.userFullName,
                        interviewedBy: _vm.interviewedBy,
                        jobTitle: _vm.jobTitle,
                        applicationId: _vm.applicationId,
                        size: "sm",
                        disabled: !_vm.showInterviewButton,
                        variant: "outline",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      [
        _vm.isApproved
          ? _c(
              "div",
              { staticClass: "w-full flex mt-2" },
              [
                _vm.showAddContractorButton
                  ? _c("AddContractorToCompany", {
                      staticClass: "w-full",
                      attrs: {
                        buttonVariant: "default",
                        buttonSize: "sm",
                        fullWidth: "",
                        companyId: _vm.company.id,
                        companyName: _vm.company.business_name,
                        currentUserId: _vm.currentUser.id,
                        contractorUserId: _vm.user.id,
                        currentUserRole: _vm.currentUser.role,
                        currentUserManagerId: _vm.managerId,
                      },
                      on: { addedToCompany: _vm.handleRefetchCollection },
                    })
                  : _vm._e(),
                !_vm.isAdmin
                  ? _c("ManagerContractorRequest", {
                      staticClass: "w-full",
                      attrs: {
                        company: _vm.company,
                        currentUser: _vm.currentUser,
                        currentUserManagerId: _vm.managerId,
                        showText: false,
                        variant: "default",
                        user: _vm.user,
                      },
                      on: {
                        contractorAdded: _vm.handleRefetchCollection,
                        contractorRemoved: _vm.handleRefetchCollection,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ],
      _vm.notedialogOpen
        ? _c("NoteDisplayModel", {
            attrs: { comment: _vm.note, title: _vm.getNoteTitle },
            on: {
              close: function ($event) {
                _vm.notedialogOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }